<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div class="modal-logout scrollable -y">
      <div class="header">
        <div class="title">{{title}}</div>
        <div class="description">{{description}}</div>
      </div>
      <div class="body">
        <div class="content">
          <div class="action-btns">
            <div
            id="logout-logout"
            v-on:click="logout()" ontouchstart=""
            class="action-btn red">Logout</div>
            <div
            id="logout-cancel"
            v-on:click="closeModalRequest()" ontouchstart=""
            class="action-btn">Cancel</div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'modal-logout',
  components: {
    Modal
  },
  data: function () {
    return {
      title: 'Are you sure to logout?',
      description: 'All your web apps in this browser will be logged out.'
    }
  },
  computed: {
    myEmail: function () {
      return this.$store.getters.myEmail
    }
  },
  watch: {
    myEmail: function () {
      this.setProperMessage()
    }
  },
  created: function () {
    this.setProperMessage()
  },
  methods: {
    closeModalRequest: function () {
      this.$emit('closeModalRequest')
    },
    onClickSubmit: function (e) {
      e.preventDefault()
      this.closeModalRequest()
    },
    logout: function () {
      // When an user taking this action
      // The user want to login as USER not IP
      let query = JSON.parse(JSON.stringify(this.$route.query))
      delete query['ip_name']
      this.$router.push({name: 'Logout', query: query})
    },
    setProperMessage: function () {
      let request = this.$param.options
      if (this.myEmail) {
        if ('email' in request) {
          if (this.myEmail !== request['email']) {
            this.title = 'Do you want to logout?'
            this.description = 'You are trying to login ' + request['email'] + ', but you are already logged in as ' + this.myEmail + '.'
            return
          }
        }
      }
      this.title = 'Are you sure to logout?'
      this.description = 'All your web apps in this browser will be logged out.'
    }
  }
}
</script>

<style scoped>
.modal-logout {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  font-size: 11px;
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
}

.modal-logout .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 32px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-logout .header .title {
  /* common */
  font-size: 2em;
}
.modal-logout .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}


.modal-logout .error-message {
  /* common */
  background-color: hsla(0, 100%, 65%, 1);
  color: #fff;
  /* text */
  text-transform: uppercase;
  font-weight: bold;
  /* size */
  width: 100%;
  /* height: 3em; */
  padding: 1em 0;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


.modal-logout .body {
  /* size */
  padding: 0 32px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}

.modal-logout .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}


.modal-logout .body .content .info-container:first-child {
  margin-top: 0;
}
.modal-logout .body .content .info-container {
  /* size */
  margin: 1em 0;
}
.modal-logout .body .content .info-container > input {
  /* common */
  background-color: hsla(0, 100%, 0%, 0.1);
  /* size */
  width: calc(100% - 1em);
  padding: 0.5em;
}





.modal-logout .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.modal-logout .body .content .action-btn.red {
  /* common */
  background-color: var(--danger);
  color: #fff;
}
.modal-logout .body .content .action-btn.dark {
  /* common */
  background-color: hsla(202, 0%, 10%, 1);
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalLogout.vue